import { ChangeEvent } from 'react';

import { Button } from 'components/Button/Button';
import { ScrollArea } from 'components/ScrollArea/ScrollArea';
import { Stack } from 'components/Stack/Stack';
import { SearchJobsFilterKeys } from 'modules/search/constants/filters/searchJobsFilters';
import { useSearchFacetReset } from 'modules/search/hooks/filters/useSearchFacetReset';
import { useSearchSelectFacetOption } from 'modules/search/hooks/filters/useSearchSelectFacetOption';
import { spacing } from 'theme/theme';

import {
  SearchFilterFacetOptionInput,
  SearchFilterFacetOptionLabel,
  SearchFilterFacetOptionsHolder,
} from './SearchFilterFacetOptions.styled';

export type Props = {
  facetType: SearchJobsFilterKeys;
  hasSearch?: boolean;
  initialValue?: string[] | string;
  options: { value: string; label: string }[];
  variant?: 'accordion' | 'dropdown';
};

export function SearchFilterRadioButtonFacetOptions({
  initialValue = [],
  facetType,
  hasSearch,
  options,
  variant = 'dropdown',
}: Props) {
  const resetFacet = useSearchFacetReset(facetType);
  const selectFacet = useSearchSelectFacetOption(facetType);

  return (
    <SearchFilterFacetOptionsHolder>
      <ScrollArea
        direction="vertical"
        height="430px"
        showScrollShadowStart={hasSearch}
        showScrollShadowEnd={hasSearch}
        scrollShadowSize={spacing[24]}
      >
        <Stack direction="column" spacing={spacing[4]}>
          {options.map((option) => (
            <SearchFilterFacetOptionLabel key={option.label}>
              <SearchFilterFacetOptionInput
                defaultChecked={initialValue === option.value}
                onChange={(e: ChangeEvent<HTMLInputElement>) =>
                  selectFacet(e.target.value)
                }
                value={option.value}
                name={`${facetType}-${variant}`} // We have to add variant to the `name` for radio buttons, otherwise the "overflow" version will default to being empty.
                type="radio"
              />
              {option.label}
            </SearchFilterFacetOptionLabel>
          ))}
        </Stack>
      </ScrollArea>
      <Button variant="secondary" type="button" onClick={resetFacet}>
        {getText('Reset')}
      </Button>
    </SearchFilterFacetOptionsHolder>
  );
}
